import en from './en.json';
import ru from './ru.json';
import ko from './ko.json';
import it from './it.json';
import fr from './fr.json';
import zh_CN from './zh_CN.json';

export default { en, ru, ko, it, fr, zh_CN };
